import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767e2292"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增活动专区")
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("开启")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 上传 ")
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "活动专区" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.addApply
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该活动专区?",
                    onConfirm: ($event: any) => ($setup.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: "活动专区",
      onOk: _cache[4] || (_cache[4] = ($event: any) => ($setup.onSubmit('formRef')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: $setup.formRef,
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "专区名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                  placeholder: "请输入专区名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "专区描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.synopsis,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.synopsis) = $event)),
                  placeholder: "请输入专区描述"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.status,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.status) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value:  'on'  }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value:  'off'  }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "图片"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.fileList,
                  class: "avatar-uploader",
                  headers: $setup.uploadHeaders,
                  action: $setup.uploadAction,
                  data: $setup.uploadFormData,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_icon, { type: "upload" }),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange"]),
                _createElementVNode("img", {
                  src: _ctx.formState.image,
                  style: {"width":"50px","margin-top":"10px"}
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}